const defaultState = {
    settings: [],
}

const SET_SETTINGS = "SET_SETTINGS"

export const settingsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SETTINGS:
            return {...state, settings: action.payload}

        default:
            return state
    }
}

export const setSettingsAction = (payload) => ({type: SET_SETTINGS, payload})
